import { useContext } from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { TableContext } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/TableContext'

type ToolbarProps = {
  className?: string
  endingDate?: string
  children?: React.ReactNode
  footerId?: string
  isFetching?: boolean
}

export function Toolbar({
  className,
  children,
  footerId,
  isFetching,
}: ToolbarProps) {
  const context = useContext(TableContext)

  // Ensure that the component is used within the correct context provider
  if (!context)
    throw new Error(
      '<TablePegawaiPenetapan.Toolbar> must be used within a <TablePegawaiPenetapan.Provider>'
    )

  const { selectedIds, isAllSentToPPK, meta } = context
  const numOfSelected = selectedIds.size

  if (isFetching) return null

  // Hide the toolbar if nothing is selectable and there is no ongoing toolbar action
  if (isAllSentToPPK && meta?.total > 0)
    return (
      <div
        className={clsx(
          'w-full bg-surface-success-subdued text-center py-9',
          className
        )}
      >
        <Text color="success" variant="body-lg" className="!font-semibold">
          Semua Rekomendasi Predikat Kinerja berhasil dikirim ke Pejabat Penilai
          Kinerja
        </Text>
      </div>
    )

  return (
    <div className={clsx('w-full', className)}>
      <div id={footerId} className="w-full px-8 py-4">
        <div
          className={clsx('flex items-center justify-between gap-10 mx-auto')}
        >
          <div className="space-y-1">
            <Text variant="body-lg" className="!font-semibold">
              {numOfSelected} Nama Dipilih
            </Text>
            <Text color="subdued">
              Anda dapat melakukan Rekomendasi Predikat Kinerja untuk banyak
              nama sekaligus.
            </Text>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
